import PropType from 'prop-types'
import styled from 'styled-components'
import { position } from 'styled-system'

import { Box, Text } from '@redriverpress/system'
import Logo from './illustrations/Logo'
import { Link } from './typography'

const StyledNav = styled.nav`
  height: 5rem;
  ${position}
`

export default function Navbar({ signIn, ...props }) {
  const loginLink = `/sign_in${window.location.search}`

  return (
    <StyledNav ariaLabel='Ellii' ariaRole='menubar' {...props}>
      <Box display='flex' alignItems='center' height='100%'>
        <Link href='/' lineHeight='single' reset mr={4} display='inline-flex'>
          <Logo height='24px' />
        </Link>

        {signIn && (
          <Box ml='auto' fontSize={0}>
            <Text display={['none', null, 'inline-block']} pr={2}>
              Have an account?
            </Text>
            <Link ariaRole='menuitem' href={loginLink}>
              Log In
            </Link>
          </Box>
        )}
      </Box>
    </StyledNav>
  )
}

Navbar.propTypes = {
  signIn: PropType.bool,
}

Navbar.defaultProps = {
  signIn: true,
}
